import { render, staticRenderFns } from "./ILPHomeDisclaimer.vue?vue&type=template&id=1aa31672&scoped=true&"
import script from "./ILPHomeDisclaimer.vue?vue&type=script&lang=js&"
export * from "./ILPHomeDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./ILPHomeDisclaimer.vue?vue&type=style&index=0&id=1aa31672&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa31672",
  null
  
)

export default component.exports